import { Component } from '@angular/core';

@Component({
  selector: 'app-term-cond',
  imports: [],
  templateUrl: './term-cond.component.html',
  styleUrl: './term-cond.component.scss'
})
export class TermCondComponent {

}
